import { Outlet } from "react-router";
import { H1, Body } from "@datapay-by-datacom/design-system";
import { AgenticPlatformNavTabs } from "../components";
import styles from "./AgenticPlatformScreen.module.css";

export function AgenticPlatformScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <H1>Agentic Platform</H1>
      </div>
      <Body className={styles.description}>
        System-level configuration for agents and capabilities. Organisation
        workspaces configure service accounts and run agents from the Knowledge
        Base Agents tab.
      </Body>
      <AgenticPlatformNavTabs />
      <Outlet />
    </div>
  );
}
